// Generated by Melange

import * as Stdlib from "melange/stdlib.js";
import * as JsxRuntime from "react/jsx-runtime";

function s(prim) {
  return prim;
}

function CompSettings(Props) {
  let giveFraction = Props.giveFraction;
  let earthRadius = Props.earthRadius;
  let earthMath = Props.earthMath;
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsxs("table", {
        children: [
          JsxRuntime.jsx("thead", {
            children: JsxRuntime.jsxs("tr", {
              children: [
                JsxRuntime.jsx("th", {
                  colSpan: 3
                }),
                JsxRuntime.jsx("th", {
                  children: "Value"
                })
              ]
            })
          }),
          JsxRuntime.jsxs("tbody", {
            children: [
              JsxRuntime.jsxs("tr", {
                children: [
                  JsxRuntime.jsx("th", {
                    children: "* Give"
                  }),
                  JsxRuntime.jsx("td", {
                    children: "give fraction only, no give distance",
                    colSpan: 2
                  }),
                  JsxRuntime.jsx("td", {
                    children: Stdlib.string_of_float(giveFraction)
                  })
                ]
              }),
              JsxRuntime.jsxs("tr", {
                children: [
                  JsxRuntime.jsx("th", {
                    children: "Earth model"
                  }),
                  JsxRuntime.jsx("td", {
                    children: "Sphere with radius",
                    colSpan: 2
                  }),
                  JsxRuntime.jsx("td", {
                    children: earthRadius
                  })
                ]
              }),
              JsxRuntime.jsxs("tr", {
                children: [
                  JsxRuntime.jsx("th", {
                    children: "Earth math",
                    colSpan: 3
                  }),
                  JsxRuntime.jsx("td", {
                    children: earthMath
                  })
                ]
              })
            ]
          }),
          JsxRuntime.jsx("tfoot", {
            children: JsxRuntime.jsx("tr", {
              children: JsxRuntime.jsx("td", {
                children: "* Adjusting the turnpoint radius with some give for pilots just short of the control zone",
                colSpan: 4
              })
            })
          })
        ],
        className: "table is-bordered"
      })]
  });
}

const make = CompSettings;

export {
  s,
  make,
}
/* react/jsx-runtime Not a pure module */
